import {Alert, Box} from '@mui/material';
import Luogo from './Luogo';
import {LuogoSurveys} from './utils/slugs';
import {useLuoghi2025Auth} from './utils/useLuoghi2025Auth';

const SURVEY_PARAMS = [
    'survey0_id',
    'survey_aggiornamento_luoghi_id',
    'survey1_id',
    'survey2_id',
    'survey3_id',
    'survey4_id',
    'survey5_id',
];

// Dashboard 1 of the prototype — pagina "Luoghi da rigenerare e iniziative", livello Luogo.
const Luoghi2025 = () => {
    const {container, uoaId, surveyIds, isAuthorized} = useLuoghi2025Auth(SURVEY_PARAMS);

    if (!isAuthorized) {
        return <Alert severity='error'>Parametri mancanti o chiave non valida.</Alert>;
    }

    const surveys: LuogoSurveys = {
        iniziale: Number(surveyIds['survey0_id']),
        aggiornamento: Number(surveyIds['survey_aggiornamento_luoghi_id']),
        iniziativeIniziale: Number(surveyIds['survey1_id']),
        iniziativeAggiornamento: Number(surveyIds['survey2_id']),
        iniziativeFinale: Number(surveyIds['survey3_id']),
        fruitori: Number(surveyIds['survey4_id']),
        partecipativi: Number(surveyIds['survey5_id']),
    };

    return (
        <Box>
            <Luogo container={container!} uoaId={uoaId!} surveys={surveys} />
        </Box>
    );
};

export default Luoghi2025;
